import React from "react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {useInvestmentOfferListBreadcrumbs} from "../hooks/use_investment_offer_list_breadcrumbs";

export const InvestmentOfferListBreadcrumbs = () => {
    const breadcrumbsData = useInvestmentOfferListBreadcrumbs();
    return (
        <Breadcrumbs css={[onDesktop(mb(1))]} homePageUrl={rpAppLink.base()}>
            {breadcrumbsData.map((breadcrumb, index) => (
                <BreadcrumbsItem {...breadcrumb} key={breadcrumb.key} isLinkingToCurrentLocation={index === breadcrumbsData.length - 1} />
            ))}
        </Breadcrumbs>
    );
};
import React from "react";

import {mb, onDesktop} from "@pg-design/helpers-css";
import {rpAppLink} from "@pg-mono/rp-routes";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {useInvestmentOfferListBreadcrumbs} from "../hooks/use_investment_offer_list_breadcrumbs";

export const InvestmentOfferListBreadcrumbs = () => {
    const breadcrumbsData = useInvestmentOfferListBreadcrumbs();
    return (
        <Breadcrumbs css={[onDesktop(mb(1))]} homePageUrl={rpAppLink.base()}>
            {breadcrumbsData.map((breadcrumb, index) => (
                <BreadcrumbsItem {...breadcrumb} key={breadcrumb.key} isLinkingToCurrentLocation={index === breadcrumbsData.length - 1} />
            ))}
        </Breadcrumbs>
    );
};
